import React from 'react';
import './Download.css';

const PaymentPage = () => {
  return (
    <div className="payment-wrapper container">
      <div className="row align-items-center">
        {/* Left Section */}
        <div className="col-md-6 mt-5 mb-5">
          <h1 className="heading" style={{lineHeight:"1.3"}}>
           Simplifying payments for a <br />digital future.
          </h1>
        <h5 style={{ paddingTop: "20px" ,lineHeight:"1.4"}}>✔ Make payments, send & receive money instantly & <br /><span style={{marginLeft:"20px"}}>all with a tap!</span></h5>
<h5>✔ Track your transactions in real-time</h5>
<h5>✔ Send and receive money globally in just a few taps</h5>


          <div className="download-section mb-5 mt-5">
            <img src="/qr.png" alt="Download QR" className="download-qr" />
          </div>
               {/* App Store & Play Store Badges */}
            <div className="store-buttons" >
              <a
                href="https://play.google.com/store/apps/details?id=com.ta.wallet.tawallet&hl=en_IN"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Google_Play_Store_badge_EN.svg/512px-Google_Play_Store_badge_EN.svg.png"
                  alt="Get it on Google Play"
                  className="store-badge"
                />
              </a>

              <a
                href="https://apps.apple.com/in/app/ta-wallet/id1381087275"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                  alt="Download on the App Store"
                  className="store-badge"
                />
              </a>
            </div>
        </div>

        {/* Right Section */}
        <div className="col-md-6 text-center">
          <div className="phone-mockup">
            <img src="/downloadimg.png" alt="QR Code on Phone" className="qr-image" />
            {/* <img src="/scanner3.png" alt="Mobikwik Standee" className="standee-image" /> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentPage;
